import React from 'react';
import './LoadingSpinner.scss';

const LoadingSpinner = (props) => {
    return (
        <span className='LoadingSpinner'>

        </span>
    );
}

export default LoadingSpinner;
